<template>
  <div class="companyInformationView-all-box clearfix">
    <card>
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        class="demo-ruleForm clearfix"
        label-position="left"
      >
        <el-form-item v-if="type !== 'add'" prop="companyCode">
          <div class="title-name">{{ $t("formData.companyCode") }}</div>
          <el-input v-model="ruleForm.companyCode" disabled :placeholder="$t('queryForm.pleaseEnter')" />
        </el-form-item>

        <el-form-item prop="companyName">
          <div class="title-name">{{ $t("formData.companyName") }}<span>*</span></div>
          <el-input v-model="ruleForm.companyName" :placeholder="$t('queryForm.pleaseEnter')" />
        </el-form-item>

        <el-form-item prop="entityType">
          <div class="title-name">{{ $t("formData.entityType") }}</div>
          <el-select v-model="ruleForm.entityType" :placeholder="$t('queryForm.pleaseSelect')">
            <el-option
              v-for="(item, index) in selectInfoObj.entityType"
              :key="'entityType'+index"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>

        <el-form-item prop="technicalArea">
          <div class="title-name">{{ $t("formData.technicalArea") }}<span>*</span></div>
          <el-select v-model="ruleForm.technicalArea" multiple :placeholder="$t('queryForm.pleaseSelect')">
            <el-option
              v-for="(item, index) in selectInfoObj.technicalArea"
              :key="'technicalArea'+index"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>

        <el-form-item prop="headQuarter">
          <div class="title-name">{{ $t("formData.headQuarter") }}<span>*</span></div>
          <el-cascader
            v-model="ruleForm.headQuarter"
            :options="selectInfoObj.headQuarter"
            :props="headQuarter"
            :placeholder="$t('queryForm.pleaseSelect')"
          />
        </el-form-item>

        <el-form-item prop="numberEmployess">
          <div class="title-name">{{ $t("formData.numberOfEmployees") }}</div>
          <el-select v-model="ruleForm.numberEmployess" :placeholder="$t('queryForm.pleaseSelect')">
            <el-option
              v-for="(item, index) in selectInfoObj.numberEmployess"
              :key="'numberEmployess'+index"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>

        <el-form-item prop="annualRevenue">
          <div class="title-name">{{ $t("formData.annualRevenue") }}</div>
          <el-select v-model="ruleForm.annualRevenue" :placeholder="$t('queryForm.pleaseSelect')">
            <el-option
              v-for="(item, index) in selectInfoObj.annualRevenue"
              :key="'annual'+index"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>

        <el-form-item prop="companyLegalPerson">
          <div class="title-name">{{ $t("formData.companyLegalPerson") }}</div>
          <el-input v-model="ruleForm.companyLegalPerson" :placeholder="$t('queryForm.pleaseEnter')" />
        </el-form-item>

        <el-form-item prop="companyCeo">
          <div class="title-name">{{ $t("formData.companyCEO") }}</div>
          <el-input v-model="ruleForm.companyCeo" :placeholder="$t('queryForm.pleaseEnter')" />
        </el-form-item>

        <el-form-item prop="companyContactPerson">
          <div class="title-name">{{ $t("formData.companyContactPerson") }}<span>*</span></div>
          <el-input v-model="ruleForm.companyContactPerson" :placeholder="$t('queryForm.pleaseEnter')" />
        </el-form-item>

        <el-form-item prop="mobilePhone">
          <div class="title-name">{{ $t("formData.mobilePhone") }}<span>*</span></div>
          <el-input
            v-model="ruleForm.mobilePhone"
            :placeholder="$t('queryForm.pleaseEnter')"
          />
        </el-form-item>

        <el-form-item prop="companyPhone">
          <div class="title-name">{{ $t("formData.companyPhone") }}</div>
          <el-input
            v-model="ruleForm.companyPhone"
            :placeholder="$t('queryForm.pleaseEnter')"
          />
        </el-form-item>

        <el-form-item prop="companyAddress" class="line">
          <div class="title-name">{{ $t("formData.companyAddress") }}</div>
          <el-cascader
            v-model="ruleForm.companyAddress"
            :options="selectInfoObj.headQuarter"
            :props="headQuarter"
            :placeholder="$t('queryForm.pleaseSelect')"
          />
        </el-form-item>

        <el-form-item class="line">
          <el-input v-model="ruleForm.detailAddress" :placeholder="$t('queryForm.pleaseEnter')" />
        </el-form-item>

        <el-form-item class="line">
          <div class="title-name">{{ $t("formData.remarks") }}</div>
          <el-input v-model="ruleForm.remarks" :placeholder="$t('queryForm.pleaseEnter')" />

          <uploadlist
            style="margin-top: 20px"
            ext-allow="pdf,doc,docx,xls,xlsx,rar,zip,wps,txt,jpg,bmp,gif,png"
            :size-forbid="30"
            :file-list="fileList"
            :type="'edit'"
          />
        </el-form-item>

        <!-- <el-form-item prop="isAvaliable">
          <div class="title-name">{{ $t("formData.isAvaliable2") }}</div>
          <el-select v-model="ruleForm.isAvaliable" :placeholder="$t('queryForm.pleaseSelect')" :disabled="userType > 1">
            <el-option :label="$t('queryForm.yes')" :value="Number(0)"/>
            <el-option :label="$t('queryForm.no')" :value="Number(1)"/>
          </el-select>
        </el-form-item> -->

        <el-form-item class="line btn-box input-form-btn-list">
          <cus-btn type="cancel" @click="cancel" />
          <cus-btn type="save" :loading="saveLoding" @click="checkFormInfo" />
        </el-form-item>
      </el-form>
    </card>
  </div>
</template>

<script>
import { companySave, companyUpdate, companyDetails } from '../../api/companyManagement'
import { getSelectInfoAll, getSelectName } from '../../utils/companyManagement'
import uploadlist from '../../components/checklist/uploadlist'

export default {
  name: 'CompanyInformationView',
  components: {
    uploadlist: uploadlist
  },
  data() {
    return {
      userType: 2,
      saveLoding: false,
      type: 'add',
      selectInfoObj: '',
      headQuarter: {
        value: 'areaNo',
        label: 'name',
        children: 'underCity'
      },
      fileList: [],
      ruleForm: {
        companyName: '',
        entityType: '',
        technicalArea: [],
        headQuarter: '',
        numberEmployess: '',
        annualRevenue: '',
        companyLegalPerson: '',
        companyCeo: '',
        companyContactPerson: '',
        mobilePhone: '',
        companyPhone: '',
        companyAddress: '',
        detailAddress: '',
        isAvaliable: 0,
        remarks: ''
      }
    }
  },
  computed: {
    rules() {
      return {
        companyName: [{ required: true, message: this.$t('queryForm.pleaseEnter'), trigger: 'change' }],
        technicalArea: [{ required: true, message: this.$t('queryForm.pleaseSelect'), trigger: 'change' }],
        headQuarter: [{ required: true, message: this.$t('queryForm.pleaseSelect'), trigger: 'change' }],
        companyContactPerson: [{ required: true, message: this.$t('queryForm.pleaseEnter'), trigger: 'change' }],
        mobilePhone: [{ required: true, message: this.$t('queryForm.pleaseEnter'), trigger: 'change' }]
      }
    },
    lang() {
      return this.$store.state.app.language
    }
  },
  watch: {
    lang() {
      this.getSelectInfo(0)
    }
  },
  mounted() {
    const self = this
    window.companyInformationView = self
    self.userType = this.$store.state.user.userinfo.userType
    self.type = this.$route.query.type || 'edit'
    self.companyId = this.$route.query.companyId

    self.getSelectInfo(1)
  },
  methods: {
    /**
    * 验证只能输入正整数
    */
    proving1(name) {
      this.ruleForm[name] = this.ruleForm[name].replace(/[^\.\d]/g, '')
      this.ruleForm[name] = this.ruleForm[name].replace('.', '')
    },

    /**
    * 获取下拉框信息
    *  status 1 获取详情  0 不获取详情
    */
    getSelectInfo(status) {
      const self = this

      getSelectInfoAll(selectInfoObj => {
        self.selectInfoObj = selectInfoObj

        if (status === 1 && self.type === 'edit') {
          self.getCompanyDetails()
        }
      })
    },

    /**
    * 返回上一页
    */
    cancel() {
      this.$router.push({
        name: this.$route.query.backToPage
      })
    },

    /**
    * 保存
    */
    save() {
      this.saveLoding = true
      const self = this
      let temporary = self.ruleForm

      temporary = JSON.parse(JSON.stringify(temporary))
      temporary.companyFile = []
      self.fileList.forEach(item => {
        temporary.companyFile.push({
          fileUrl: item.filepath,
          fileName: item.filename,
          fileSize: item.size
        })
      })
      temporary.companyAddress = temporary.companyAddress.toString()
      temporary.headQuarter = temporary.headQuarter.toString()
      temporary.technicalArea = temporary.technicalArea.toString()

      if (self.type === 'add') {
        companySave(temporary).then(response => {
          if (response.code === 200) {
            self.cancel()
            self.$message.success(response.message)
          }
        })
          .finally(() => {
            this.saveLoding = false
          })
      } else if (self.type === 'edit') {
        companyUpdate(temporary).then(response => {
          if (response.code === 200) {
            self.cancel()
            self.$message.success(response.message)
          }
        })
          .finally(() => {
            this.saveLoding = false
          })
      }
    },

    /**
    * 检查form必选是否 有内容
    */
    checkFormInfo() {
      const self = this
      self.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          self.save()
        }
      })
    },

    /**
    * 上传组件 文件列表赋值
    */
    setFileList(fileList, name) {
      const self = this
      if (name === 'upload') {
        self.fileList = fileList
      }
    },

    /**
    * 获取公司详情
    */
    getCompanyDetails() {
      const self = this
      companyDetails({ id: self.companyId }).then(response => {
        if (response.code === 200) {
          // 年收入 有没有值
          if (response.data.annualRevenue && self.selectInfoObj.annualRevenue.length) {
            response.data.annualRevenueName = getSelectName(response.data.annualRevenue, self.selectInfoObj.annualRevenue)
          }

          // 公司类型 有没有值
          if (response.data.entityType && self.selectInfoObj.entityType.length) {
            response.data.entityTypeName = getSelectName(response.data.entityType, self.selectInfoObj.entityType)
          }

          // 员工人数 有没有值
          if (response.data.numberEmployess && self.selectInfoObj.numberEmployess.length) {
            response.data.numberEmployessName = getSelectName(response.data.numberEmployess, self.selectInfoObj.numberEmployess)
          }

          // 技术领域 有没有值
          if (response.data.technicalArea && self.selectInfoObj.technicalArea.length) {
            response.data.technicalArea = response.data.technicalArea.split(',')
          }

          // 公司地址
          if (response.data.companyAddress) {
            response.data.companyAddress = response.data.companyAddress.split(',')
          }

          // 总部
          if (response.data.headQuarter) {
            response.data.headQuarter = response.data.headQuarter.split(',')
          }

          if (response.data.companyFile && Array.isArray(response.data.companyFile) && response.data.companyFile.length) {
            self.fileList = []
            response.data.companyFile.forEach(item => {
              self.fileList.push({
                filename: item.fileName,
                filepath: item.fileUrl,
                progress: 100
              })
            })
          }

          self.ruleForm = response.data
        }
      })
    }

  }
}
</script>

<style scoped lang="scss">
    .companyInformationView-all-box {

    }
</style>
